import Page from "../../../../modules/Core/Components/Page";
import templateDefault from "../../../templates/default/pages/world/limelight";

export default class Limelight extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Limelight")} | ${this.ucfirst("window-title")}`
    );
  }
}
